/**
 * BUSINESS LOGIC: INTERACTIVE CHAT OVERLAY
 */
import { 
    ShowInteractiveMessage as DLShowInteractiveMessage,
    HideInteractiveMessage as DLHideInteractiveMessage,
    GetInteractiveChatConfig as DLGetInteractiveChatConfig,
    SetInteractiveChatConfig as DLSetInteractiveChatConfig,
    GetQuickReplies as DLGetQuickReplies,
    SaveQuickReply as DLSaveQuickReply,
    DeleteQuickReply as DLDeleteQuickReply,
    ReorderQuickReplies as DLReorderQuickReplies
} from './../DL/InteractiveChat'

export const ShowInteractiveMessage = async (text) => {
    if (!text || text.trim() === '') return { success: false, message: 'El mensaje no puede estar vacío.' };
    return await DLShowInteractiveMessage(text.trim());
};

export const HideInteractiveMessage = async () => {
    return await DLHideInteractiveMessage();
};

export const GetInteractiveChatConfig = async () => {
    return await DLGetInteractiveChatConfig();
};

export const SetInteractiveChatConfig = async (config) => {
    return await DLSetInteractiveChatConfig(config);
};

export const GetQuickReplies = async () => {
    return await DLGetQuickReplies();
};

export const SaveQuickReply = async (text) => {
    if (!text || text.trim() === '') return { success: false, message: 'El mensaje no puede estar vacío.' };
    return await DLSaveQuickReply(text.trim());
};

export const DeleteQuickReply = async (id) => {
    return await DLDeleteQuickReply(id);
};

export const ReorderQuickReplies = async (orderedIds) => {
    if (!orderedIds || orderedIds.length === 0) return { success: false, message: 'La lista no puede estar vacía.' };
    return await DLReorderQuickReplies(orderedIds);
};